import { HStack } from '@chakra-ui/react';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { SuggestionBackButton } from '~/components/ui/tabs/components/BackButton';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';

const PRICE_RANGES = [
  { label: '0 - 2 mkr', min: 0, max: 2_000_000 },
  { label: '2 - 4 mkr', min: 2_000_000, max: 4_000_000 },
  { label: '4 - 6 mkr', min: 4_000_000, max: 6_000_000 },
  { label: '6 - 8 mkr', min: 6_000_000, max: 8_000_000 },
  { label: '8 - 10 mkr', min: 8_000_000, max: 10_000_000 },
  { label: '10+ mkr', min: 10_000_000, max: null },
];

export const PriceRangeTabContent = () => {
  const filters = useHomesStore((state) => state.filters);
  const { price_min, price_max } = filters || {};
  const { performSearch } = useFilters();

  const isActive = (range: { min: number; max: number | null }) => {
    return price_min === range.min && price_max === range.max;
  };

  const onSelectRange = (range: { min: number; max: number | null }) => {
    if (isActive(range)) {
      // Deselect
      performSearch({
        filters: { price_min: undefined, price_max: undefined },
      });
    } else {
      performSearch({
        filters: {
          price_min: range.min || undefined,
          price_max: range.max || undefined,
        },
      });
    }
  };

  return (
    <HStack mb={1} alignItems="center" overflowX="hidden">
      <SuggestionBackButton
        filterKeysToRemove={['living_space_min', 'living_space_max']}
      />
      <SuggestionsButtonList>
        {PRICE_RANGES.map((range, index) => (
          <SuggestionsButton
            key={index}
            label={range.label}
            isActive={isActive(range)}
            onClick={() => onSelectRange(range)}
          />
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
};
